<script lang="ts">
	import ReaderNavControls from '$lib/components/reader/reader-nav-controls.svelte';
	import ReaderHeader from '$lib/components/reader/reader-header.svelte';
	import { ScrollArea } from '$lib/components/ui/scroll-area';

	let { data, children } = $props();

	let storyPageNumber = $derived(data.storyPageNumber);
	let storyMetadata = $derived(data.storyMetadata);
	let storySlug = $derived(data.storySlug);
</script>

<div class="relative flex h-[100dvh] flex-col">
	<div class="container flex-none">
		<div class="mx-auto max-w-prose pb-2 md:pb-4 lg:pb-8">
			<ReaderHeader storyTitle={storyMetadata.title} />
		</div>
	</div>

	<!-- Scrollable content area -->
	<div class="flex-1 overflow-hidden">
		<ScrollArea class="h-full">
			<div class="container pb-28">
				<div class="mx-auto max-w-prose">
					{@render children()}
				</div>
			</div>
		</ScrollArea>
	</div>

	<!-- Fixed navigation controls -->
	<div class="absolute bottom-2 left-0 right-0 z-40 px-4 md:bottom-6">
		<div class="mx-auto max-w-prose">
			<ReaderNavControls
				currentPage={Number(storyPageNumber)}
				totalPages={storyMetadata.number_of_pages}
				{storySlug}
			/>
		</div>
	</div>
</div>
